(() => {
  if (customElements.get('wolf-card-swatches')) return;

  class WolfCardSwatches extends HTMLElement {
    connectedCallback() {
      this.swatches = [...this.querySelectorAll('.collection-variants-inner')];
      this.more = this.querySelector('[data-more-colors]');
      if (!this.swatches.length || !this.more) return;
      this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
      this.resizeObserver.observe(this);
      this.scheduleLayout();
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.scheduleLayout();
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
    }

    scheduleLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => this.layout());
    }

    layout() {
      if (!this.getBoundingClientRect().width) return;
      this.setAttribute('data-ready', '');
      this.swatches.forEach((swatch) => { swatch.hidden = false; });
      this.more.hidden = true;

      const gap = Number.parseFloat(getComputedStyle(this).columnGap) || 0;
      const widths = this.swatches.map((swatch) => swatch.getBoundingClientRect().width);
      const total = widths.reduce((sum, width) => sum + width, 0) + gap * (widths.length - 1);
      // Keep the row's natural width stable as individual swatches are hidden.
      this.style.width = `${total}px`;
      const available = this.clientWidth;
      if (total <= available) return;

      this.more.hidden = false;
      let visible = widths.length - 1;
      let used = widths.slice(0, visible).reduce((sum, width) => sum + width, 0);
      while (visible >= 0) {
        const hidden = widths.length - visible;
        this.more.textContent = `+${hidden} more`;
        const required = used + gap * visible + this.more.getBoundingClientRect().width;
        if (required <= available || visible === 0) break;
        used -= widths[--visible];
      }
      this.swatches.forEach((swatch, index) => { swatch.hidden = index >= visible; });
      const hidden = widths.length - visible;
      this.more.setAttribute('aria-label', `View ${hidden} more ${hidden === 1 ? 'color' : 'colors'} for ${this.dataset.productTitle}`);
    }
  }

  customElements.define('wolf-card-swatches', WolfCardSwatches);
})();
